const API_URL = 'https://api.drugs4dent.com/';

export async function GetGroupUser() {
    //returns all  classes including Main and Sub Class hierarchy
    //console.log(`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`)
    try
    {
        return await fetch(`${API_URL}api/MimsDrug4dent/GetGroupUsers?userId=${localStorage.getItem('userId')}&groupId=${localStorage.getItem('groupId')}`,
        {
            headers: {
                'Authorization':`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`
            }
        })
        .then(data => data.json())
    }
    catch(error)
    {
        return [];
    }
}

export async function RemoveGroupUser(userId) {
    //returns all  classes including Main and Sub Class hierarchy
    //console.log(`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`)
    try
    {
        return await fetch(`${API_URL}api/MimsDrug4dent/RemoveGroupUser?userId=${userId}&groupId=${localStorage.getItem('groupId')}`,
        {
            headers: {
                'Authorization':`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`
            }
        })
        .then(data => data.json())
    }
    catch(error)
    {
        return [];
    }
}
export async function NewGroupUser(email,fullName) {
    //returns all  classes including Main and Sub Class hierarchy
    //console.log(`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`)
    try
    {
        return await fetch(`${API_URL}api/MimsDrug4dent/NewGroupUser?userId=${localStorage.getItem('userId')}&groupId=${localStorage.getItem('groupId')}&email=${email}&fullName=${fullName}`,
        {
            headers: {
                'Authorization':`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`
            }
        })
        .then(data => data.json())
    }
    catch(error)
    {
        return [];
    }
}